export default __webpack_public_path__ + "static/media/pre-op-2.c20d6666.jpg";